import React from 'react';
import { SectionInstance } from '../types';
import InlineEditText from '../InlineEditText';
import { sfHeadline, sfSub } from './sectionHelpers';

const ContentTimeline: React.FC<{ section: SectionInstance }> = ({ section }) => {
  const c = section.controls;
  const steps = (c.steps || []) as Array<{ step_number: string; title: string; description: string }>;

  return (
    <section style={{ padding: '80px 24px' }}>
      <div style={{ maxWidth: 768, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <InlineEditText
            tag="h2"
            controlKey="headline"
            style={{ fontSize: '2.25rem', marginBottom: 12 }}
          >
            {sfHeadline(c, 'Our Process')}
          </InlineEditText>
          {(sfSub(c) !== undefined || true) && (
            <InlineEditText
              tag="p"
              controlKey="subheadline"
              style={{ color: '#64748b', fontSize: '1.125rem' }}
            >
              {sfSub(c, 'Walk through our step-by-step process')}
            </InlineEditText>
          )}
        </div>
        {steps.map((s, i) => (
          <div key={i} style={{ display: 'flex', gap: 24, marginBottom: 32 }}>
            <div style={{
              width: 48, height: 48, borderRadius: '50%', background: 'var(--brand-primary, #2563eb)',
              color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontWeight: 700, flexShrink: 0,
            }}>
              {s.step_number}
            </div>
            <div>
              <h3 style={{ marginBottom: 4 }}>{s.title}</h3>
              <p style={{ color: '#64748b' }}>{s.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
export default ContentTimeline;
